// de-DE formatters podle Brief & Design Manual §9.

const eurNoCents = new Intl.NumberFormat("de-DE", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const eurWithCents = new Intl.NumberFormat("de-DE", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const dateShort = new Intl.DateTimeFormat("de-DE", {
  day: "numeric",
  month: "numeric",
});

const dateLong = new Intl.DateTimeFormat("de-DE", {
  day: "numeric",
  month: "long",
  year: "numeric",
});

const weekday = new Intl.DateTimeFormat("de-DE", { weekday: "short" });
const weekdayLong = new Intl.DateTimeFormat("de-DE", { weekday: "long" });

export function fmtEur(value: number | null | undefined): string {
  if (value == null) return "—";
  return `${eurNoCents.format(value)} €`;
}

export function fmtEurCents(value: number | null | undefined): string {
  if (value == null) return "—";
  return `${eurWithCents.format(value)} €`;
}

export function fmtDateShort(value: string | Date | null | undefined): string {
  if (!value) return "—";
  const d = typeof value === "string" ? new Date(value) : value;
  return `${dateShort.format(d)}.`;
}

export function fmtDateLong(value: string | Date | null | undefined): string {
  if (!value) return "—";
  return dateLong.format(typeof value === "string" ? new Date(value) : value);
}

export function fmtWeekday(value: string | Date): string {
  return weekday.format(typeof value === "string" ? new Date(value) : value);
}

export function fmtWeekdayLong(value: string | Date): string {
  return weekdayLong.format(typeof value === "string" ? new Date(value) : value);
}

export function fmtTime(value: string | Date | null | undefined): string {
  if (!value) return "—";
  const d = typeof value === "string" ? new Date(value) : value;
  return d.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" });
}

/** "5.–11. Mai" range used in dashboard section labels. */
export function fmtWeekRange(start: Date, end: Date): string {
  const startDay = start.getDate();
  const endDay = end.getDate();
  const month = new Intl.DateTimeFormat("de-DE", { month: "long" }).format(end);
  return `${startDay}.–${endDay}. ${month}`;
}
